import { createSlice } from '@reduxjs/toolkit';
import fetchPathologistUser from "../../../rtk-apis/pathologistuser/getPathologistUser";

// Define the initial state
const initialState = {
  status: '',
  result: [],
  msg: '',
  loading: false,
  error: '',
};

const pathologistUserSlice = createSlice({
  name: 'pathologistUserSlice',
  initialState,
  reducers: {
    // Reducer to reset the state to its initial values
    resetpathologistUser: (state) => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    console.log('----------', builder);
    builder
      .addCase(fetchPathologistUser.pending, (state) => {
        console.log('Pending');
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchPathologistUser.fulfilled, (state, { payload }) => {
        console.log('Fulfilled', payload);
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(fetchPathologistUser.rejected, (state, { error }) => {
        console.log('Rejected');
        state.loading = false;
        state.error = error.message || 'Something went wrong';
      });
  },
});

export const { resetpathologistUser } = pathologistUserSlice.actions;

export default pathologistUserSlice.reducer;
